import { scene7StockImageMode } from '../../utils/constants';

export const SortOrder = {
  Asc: 0,
  Desc: 1,
};

export const sortBasedOnRecentBomOptionsList = (originalBomOptionsList, recentBomOptionsList, orderBy) => {
  if (
    !originalBomOptionsList ||
    originalBomOptionsList.length === 0 ||
    !recentBomOptionsList ||
    recentBomOptionsList.length === 0
  ) {
    return originalBomOptionsList;
  }

  const mappedIndices = [];
  const optionsInRecentList = [];
  const otherOptions = [];
  originalBomOptionsList.forEach((option, index) => {
    const indexOfRecentList = recentBomOptionsList.findIndex(
      (recentOption) => recentOption.code === option.code && recentOption.codeValue === option.codeValue
    );
    if (indexOfRecentList >= 0) {
      mappedIndices.push({ indexOfRecentList, originalIndex: index });
      optionsInRecentList.push(option);
    } else {
      otherOptions.push(option);
    }
  });

  const sortedOptions = mappedIndices
    .sort((a, b) => a.indexOfRecentList - b.indexOfRecentList)
    .map((indexPair) => originalBomOptionsList[indexPair.originalIndex]);

  return orderBy === SortOrder.Desc
    ? [...sortedOptions.reverse(), ...otherOptions]
    : [...otherOptions, ...sortedOptions];
};

export const generateBomOptionGalleryName = (option, specs) => {
  const { code, codeValue, useTexture } = option;
  const { galleryColorizedStockImageExistence, itemId, twinItemId } = specs;
  const tmpItemId =
    galleryColorizedStockImageExistence === scene7StockImageMode.TwinItemExist && !!twinItemId ? twinItemId : itemId;
  return useTexture ? `texture_${tmpItemId}_${code}_${codeValue}` : `product_${tmpItemId}_c_${codeValue}`;
};
